import { manifest } from '../config/manifest';

export default function Watermark() {
  // Diagonal repeated watermark across the viewport.
  // CSS-only; UX rather than security (any user can remove via dev tools —
  // the actual security boundary is the auth-gated /api/content/:slug call).
  const text = manifest.site.watermark;
  return (
    <div className="watermark" aria-hidden="true">
      <div className="watermark__text">{text}</div>
    </div>
  );
}
